/**
 * 登録種別の定数定義
 */
export namespace RegisterType {
  /**
   * 登録種別の型
   */
  type TypeRegistration = number | null

  /** 外部連携 */
  export const EXTERNAL: TypeRegistration = null

  /** 管理画面からの手動登録 */
  export const SELF_REGIST: TypeRegistration = 1
}
